import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from 'DesignSystem/ui/toast';
import { useToast } from 'DesignSystem/ui/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const content = (
          <div key={`${id}-content`} className="grid min-w-0 flex-1 gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
            {variant === 'error' ? action : null}
          </div>
        );

        return (
          <Toast key={id} variant={variant} {...props}>
            {variant === 'success' || variant === 'error' ? (
              <div className="flex min-w-0 flex-1 items-start gap-3">
                <ToastIcon variant={variant} />
                {content}
              </div>
            ) : (
              content
            )}
            {variant === 'error' ? null : action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
